module.exports = __webpack_public_path__ + "media/3_6-8.5cf90497.mp3";